import React from 'react';

/**
 * Shared recipe for a vertically scrolling flex column that works on mobile.
 * `minHeight: 0` lets the flex item shrink so overflow actually engages;
 * the two touch properties keep iOS momentum scrolling inside the container.
 * Used by the chat message list and both share viewers — change it here, not
 * per-component (same pattern as tableStyles.ts).
 */
export const touchScrollColumn: React.CSSProperties = {
  flex: 1,
  minHeight: 0,
  overflowY: 'auto',
  WebkitOverflowScrolling: 'touch',
  overscrollBehavior: 'contain',
};
